import * as jacktearleapi from '@/api/api.jacktearle.dev.js'
import { StringToUrl } from '@/utils/string-utils.js'

export function BlogPostToTileItem (post) {
  return {
    title: post.title,
    previewText: post.preview,
    routeName: 'blogdetail',
    routeParameters: {
      postid: post.id,
      description: StringToUrl(post.title)
    },
    previewImageSrc: jacktearleapi.GetPostImage(
      post.id,
      post.previewImageSrc
    ),
    previewImageAlt: post.previewImageAlt,
    id: post.id
  }
}
